import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    title: "Platform operator",
    paragraphs: ["Fitygrity Private Limited operates fitygrity.com. By using this platform you agree to these terms."],
  },
  {
    title: "Eligibility and accounts",
    paragraphs: [
      "Users must be 18 or older to register.",
      "Fitygrity reserves the right to remove any account violating community standards.",
    ],
  },
  {
    title: "Virtual challenge fees",
    paragraphs: ["Entry fees for virtual challenges are non-refundable once the challenge has started."],
  },
  {
    title: "Third-party races and travel",
    paragraphs: ["Fitygrity is not liable for third-party race events listed on the platform."],
  },
  {
    title: "Jurisdiction",
    paragraphs: ["Disputes shall be subject to the jurisdiction of courts in Gurugram, Haryana, India."],
  },
  {
    title: "Contact",
    paragraphs: ["Questions about these terms can be sent to info@fitygrity.com."],
  },
];

export default function Terms() {
  return (
    <LegalPage
      testId="terms-page"
      eyebrow="Legal"
      title="Terms of Service"
      updated="October 7, 2026"
      intro="These terms govern your use of Fitygrity, including athlete accounts, virtual challenges, race listings, training content and travel enquiries."
      sections={SECTIONS}
    />
  );
}
